import AmenitiesList from './AmenitiesList';
export default AmenitiesList;
